import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { GridHeaderFilterModule } from '@portal-core/ui/grid/components/grid-header-filter/grid-header-filter.module';
import { GridHeaderFilterFormModule } from '@portal-core/ui/grid/directives/grid-header-filter-form/grid-header-filter-form.module';
import { GridHeaderFilterMenuModule } from '@portal-core/ui/grid/directives/grid-header-filter-menu/grid-header-filter-menu.module';
import { GridBooleanFilterComponent } from './grid-boolean-filter.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    GridHeaderFilterFormModule,
    GridHeaderFilterMenuModule,
    GridHeaderFilterModule,
    MatButtonModule,
    MatFormFieldModule,
    MatRadioModule,
    ReactiveFormsModule
  ],
  declarations: [
    GridBooleanFilterComponent
  ],
  exports: [
    GridBooleanFilterComponent
  ]
})
export class GridBooleanFilterModule { }
